'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
var SmallTitleText = require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var KeyboardArrowDownIcon = _interopDefault(require('@material-ui/icons/KeyboardArrowDown'));
var styledComponents = require('./styled-components.js');

var MultiSelectWithTopLabel = function (props) {
    var _a = props.menuItems, menuItems = _a === void 0 ? [] : _a, title = props.title, defaultValue = props.defaultValue, reporter = props.reporter, Icon = props.Icon, _b = props.className, className = _b === void 0 ? '' : _b, _c = props.placeholder, placeholder = _c === void 0 ? '' : _c, _d = props.error, error = _d === void 0 ? false : _d, _e = props.disabled, disabledInput = _e === void 0 ? false : _e;
    var _f = React__default.useState(defaultValue || []), selectedItems = _f[0], setSelectedItems = _f[1];
    var _g = React__default.useState(false), canOpen = _g[0], setCanOpen = _g[1];
    var selectHandleOnOpen = function () {
        if (!disabledInput)
            setCanOpen(!canOpen);
    };
    var handleChange = function (event) {
        event.preventDefault();
        event.stopPropagation();
        setSelectedItems(event.target.value);
    };
    var handleDelete = function (event, itemToRemove) {
        event.preventDefault();
        event.stopPropagation();
        setSelectedItems(selectedItems.filter(function (item) { return item !== itemToRemove; }));
    };
    var menuItemsByID = menuItems.reduce(function (itemsByID, menuItem) {
        itemsByID[menuItem.value] = menuItem; // eslint-disable-line no-param-reassign
        return itemsByID;
    }, {});
    React.useEffect(function () {
        reporter(selectedItems);
    }, [selectedItems, reporter]);
    return (React__default.createElement(styledComponents.Main, { className: className },
        title && React__default.createElement(styledComponents.StyledInputLabel, null, title),
        React__default.createElement(core.Select, { "data-testid": 'multi-select', inputProps: {
                'data-testid': 'select-input',
            }, multiple: true, displayEmpty: true, value: selectedItems, onChange: handleChange, error: error, input: React__default.createElement(styledComponents.StyledInput, { error: error, disabled: disabledInput }), onClick: selectHandleOnOpen, open: canOpen, IconComponent: Icon || KeyboardArrowDownIcon, renderValue: function (selected) {
                if (selected.length === 0) {
                    return React__default.createElement(SmallTitleText, { style: { marginTop: '0.3rem' } }, placeholder);
                }
                return (React__default.createElement(styledComponents.StyledParentContainer, null, selected.map(function (value) {
                    var p = menuItemsByID[value];
                    if (!p)
                        return null;
                    return (React__default.createElement(styledComponents.StyledChip, { disabled: disabledInput, key: p.value, label: p.display, size: 'small', onDelete: !p.disabled
                            ? function (e) {
                                handleDelete(e, p.value);
                            }
                            : undefined }));
                })));
            }, MenuProps: {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                },
                getContentAnchorEl: null,
                marginThreshold: 0,
            } }, menuItems.map(function (item) { return (React__default.createElement(core.MenuItem, { key: item.value, value: item.value, disabled: item.disabled }, item.display)); }))));
};

module.exports = MultiSelectWithTopLabel;
